import React, { useRef, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";

export function Model(props) {
  const group = useRef();
  const { scene } = useGLTF("/robot.glb");

  useEffect(() => {
    scene.traverse((child) => {
      if (!child.isMesh) return;

      const mats = Array.isArray(child.material) ? child.material : [child.material];
      mats.forEach((m) => {
        if (!m) return;

        // Make it less shiny
        if ("metalness" in m) m.metalness = 0.0;   // 0 = non-metal
        if ("roughness" in m) m.roughness = 0.95;  // closer to 1 = matte

        // Reduce environment reflection strength (works in three)
        if ("envMapIntensity" in m) m.envMapIntensity = 0.2;

        m.needsUpdate = true;
      });
    });
  }, [scene]);

  useFrame((_, delta) => {
    if (!group.current) return
    group.current.rotation.y += delta * 0.25
    })

  return (
    <group ref={group} {...props} dispose={null}>
      <primitive object={scene} />
    </group>
  );
}

useGLTF.preload("/robot.glb");